import { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import type { PlanCurrency } from "shared/api/tribute/types";

import { cn } from "shared/utils/cn";
import { getCurrencySymbol } from "shared/utils/get-currency-symbol";

const CURRENCIES: PlanCurrency[] = ["eur", "usd", "rub"];

type Props = {
  className?: string;
  value: PlanCurrency;
  onChange: (value: PlanCurrency) => void;
};

// Compact dropdown that opens upwards — designed to sit next to the
// bottom-pinned action button.
export const CurrencySelect = (props: Props) => {
  const { className, value, onChange } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={cn("relative shrink-0", className)}>
      <button
        className="bg-dark-grey flex h-13 cursor-pointer items-center gap-x-1 rounded-xl px-3 text-lg leading-5.5 tracking-[0.4px] text-white transition-[filter] hover:brightness-125"
        onClick={() => setIsOpen((open) => !open)}
      >
        {getCurrencySymbol(value)}
        {isOpen ? (
          <IoChevronDown className="text-pale-grey size-4" />
        ) : (
          <IoChevronUp className="text-pale-grey size-4" />
        )}
      </button>
      {isOpen && (
        <div className="bg-dark-grey absolute bottom-full left-0 z-10 mb-2 flex flex-col overflow-hidden rounded-xl border border-white/10">
          {CURRENCIES.map((currency) => (
            <button
              key={currency}
              className={cn(
                "flex cursor-pointer items-center gap-x-2 px-3.5 py-2.5 text-left leading-5.5 whitespace-nowrap uppercase hover:bg-white/5",
                currency === value ? "text-white" : "text-pale-grey"
              )}
              onClick={() => {
                onChange(currency);
                setIsOpen(false);
              }}
            >
              <span className="w-4">{getCurrencySymbol(currency)}</span>
              {currency}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
